import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../Utilities/Loader";
import Technologies from "./Technologies";
import Requirement from "./Requirement";
import Member from "./Member";
import ReactQuill from "react-quill";
import { AnimatePresence, motion } from "framer-motion"; // 👈 Added
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline"],
    ["link"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "link",
  "list",
  "bullet",
];

const Overview = ({
  DetailedProjectData,
  projectDescriptionChange,
  isDeveloper,
}) => {
  const [value, setValue] = useState(
    (DetailedProjectData &&
      DetailedProjectData.project &&
      DetailedProjectData.project.description) ||
      "No data"
  );
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState("overview");

  const updateContent = async () => {
    try {
      setLoading(true);
      const responseData = await projectDescriptionChange({
        description: value,
        project_id: DetailedProjectData.project._id,
      });
      if (responseData && responseData.success) {
        toast.success("Project description updated");
      } else {
        toast.error(responseData.message);
      }
    } catch (err) {
      toast.error(err.error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      DetailedProjectData &&
      DetailedProjectData.project &&
      DetailedProjectData.project.description
    ) {
      setValue(DetailedProjectData.project.description);
    }
  }, [DetailedProjectData]);

  const tabTitle = [
    { id: "1", label: "Details", status: "overview" },
    { id: "2", label: "Requirements", status: "requirement" },
    { id: "3", label: "Technologies", status: "technologies" },
    { id: "4", label: "Members", status: "members" },
  ];

  const tabDetail = (DetailedProjectData, isDeveloper) => {
    switch (status) {
      case "requirement":
        return <Requirement DetailedProjectData={DetailedProjectData} />;
      case "technologies":
        return <Technologies DetailedProjectData={DetailedProjectData} />;
      case "members":
        return <Member data={DetailedProjectData} isDeveloper={isDeveloper} />;
      default:
        return (
          <div className="h-screen">
            <div className="pb-5">
              <div className="mb-2 common-editor rounded-theme-lg relative">
                <ReactQuill
                  className="font-xl h-full bg-theme-paper rounded-theme-lg border border-theme-cream-3"
                  theme="snow"
                  value={value}
                  onChange={setValue}
                  modules={modules}
                  formats={formats}
                />
              </div>
            </div>
            <button
              disabled={isLoading}
              onClick={updateContent}
              className="font-title flex items-center bg-theme-ink text-white text-sm transition duration-300 ease-out hover:bg-theme-ink-2 h-8 py-4 px-10 rounded-theme-sm font-medium"
            >
              Submit
              {isLoading ? <Loader /> : null}
            </button>
          </div>
        );
    }
  };

  return (
    <div className="mt-3">
      {/* <h1 className="font-thin text-4xl pb-10 text-theme-fg-1">Overview</h1> */}
      {/* <header className="pb-10">
        <div className="flex bg-theme-cream-2 w-fit rounded-theme-pill items-center last:pb-0">
          {tabTitle.map((item) => (
            <button
              key={item.id}
              onClick={() => setStatus(item.status)}
              className={`px-2 py-2 rounded-theme-pill ${
                status === item.status ? "bg-theme-paper h-full w-full" : ""
              } border-4 lg:px-6 border-theme-cream-2 text-[13px] lg:text-sm text-theme-fg-2 transition duration-300 ease-out w-max ${
                item.label === "All" ? "px-6 lg:px-10" : ""
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </header> */}

      {/* ✨ Animated Tab Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={status}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          {DetailedProjectData && tabDetail(DetailedProjectData, isDeveloper)}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

const mapState = () => ({});
const mapDispatch = (dispatch) => ({
  projectDescriptionChange: dispatch.projectDetails.projectDescriptionChange,
});

export default connect(mapState, mapDispatch)(Overview);
